export class orderingModel {
  
    constructor(
      public mail: string,
      public passw: string,
      public user_id: string,
      public prov_time: string,
      public term_time: string,
      public order_time : string,
      public local_order_time: string,
      public local_prov_time: string,
      public local_term_time: string,
      public cfg: string,
      public nos: string,
      public region: string,
    ) {  }
  
  }
  


// WEBPACK FOOTER //
// ./src/app/create-workspace/http-post-request-object-classes/orderingModel.ts